<div fxLayout="column" style="height: 100% !important;">
    <div fxFlex="72px" fxFlex.xs="144px" class="header">
        <div fxLayout="row" fxFlex="960px" fxFlex.lt-md="100" style="margin: auto;">
            <div fxFlex>
                <h2 class="header">{{ 'IFrame.Title' | translate }}</h2>
            </div>

            <div fxFlex="80px" class="language-button" fxLayout="row" fxLayoutAlign="end center">
                <button mat-button fxShow fxHide.lt-md aria-label="switch language de/en" class="language"
                    (click)="switchLanguage(nextIso)" fxLayoutAlign="center center">{{nextLanguageString}}</button>
                <button mat-button fxHide fxShow.lt-md aria-label="switch language de/en" class="language"
                    (click)="switchLanguage(nextIso)" fxLayoutAlign="center center">{{nextIso|uppercase}}</button>
                <mat-icon class="globeIcon">public</mat-icon>
            </div>

        </div>
    </div>

    <div fxFlex fxLayout="row" style="background-color: #F5F5F5;">
        <div fxFlex="960px" fxFlex.lt-md="100" style="height:100%; margin: auto; background-color: white;">
            <ng-container *ngIf="currentPage === 'image'" [ngTemplateOutlet]="imageSite"></ng-container>
            <ng-container *ngIf="currentPage === 'adress'" [ngTemplateOutlet]="adressSite"></ng-container>
            <ng-container *ngIf="currentPage === 'abort'" [ngTemplateOutlet]="abortSite"></ng-container>
            <ng-container *ngIf="currentPage === 'success'" [ngTemplateOutlet]="successSite"></ng-container>
            <ng-container *ngIf="currentPage === 'error'" [ngTemplateOutlet]="errorSite"></ng-container>
            <ng-container *ngIf="currentPage === 'technicalError'" [ngTemplateOutlet]="technicalErrorSite"></ng-container>
        </div>
    </div>
</div>


<ng-template #imageSite>
    <div fxFlex="100" fxLayout="column" fxLayoutGap="9px">
        <!-- <div style="padding: 36px;">
            <div style="height: 30px; width: 100%; border:1px solid black"></div>
        </div> -->
        <div style="padding: 36px 36px 0 36px">
            <h2 class="color-90">{{'IFrame.ImageSite.Header'|translate}}</h2>
        </div>
        <div fxFlex="100" fxLayout="column" fxLayoutGap="18px" [ngStyle]="{padding: '0 17px 36px 36px'}"
            [ngStyle.lt-md]="{padding: '0 36px 36px 36px'}">

            <div fxFlex fxLayout="row" fxLayoutGap="36px" fxLayout.lt-md="column" fxLayoutGap.lt-md="18px">
                <div fxFlex style="padding-top: 15px;">
                    <div fxLayout="column" style="height: 100%;" fxLayoutGap="1em">
                        <div style="margin: 12px; margin-top: 24px;">
                            <image-upload #imageUploadComponent></image-upload>
                        </div>
                    </div>
                </div>
                <div fxFlex fxLayout="column" fxLayoutGap="9px" fxLayoutGap.lt-md="18px">
                    <div fxFlex.lt-md fxLayout="column" fxLayoutGap="9px" fxLayoutGap.lt-md="18px">
                        <div fxLayout="row" fxLayoutGap="19px" [ngStyle.lt-md]="{width: '104%'}">
                            <div fxFlex>
                                <img src="assets/images/foto-upload/shoulder-note.png" class="note-img" />
                            </div>
                            <div fxFlex>
                                <img src="assets/images/foto-upload/sunglasses_note.png" class="note-img" />
                            </div>
                            <div fxFlex>
                                <img src="assets/images/foto-upload/cap_note.png" class="note-img" />
                            </div>
                            <div fxFlex>
                                <img src="assets/images/foto-upload/sun_note.png" class="note-img" />
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutGap="19px" [ngStyle.lt-md]="{width: '104%'}">
                            <div fxFlex>
                                <img src="assets/images/foto-upload/single-note.png" class="note-img" />
                            </div>
                            <div fxFlex>
                                <img src="assets/images/foto-upload/body_note.png" class="note-img" />
                            </div>
                            <div fxFlex>
                                <img src="assets/images/foto-upload/bg_note.png" class="note-img" />
                            </div>
                            <div fxFlex>
                                <img src="assets/images/foto-upload/move_note.png" class="note-img" />
                            </div>
                        </div>
                    </div>

                    <div fxFlex.lt-md fxLayout="column" fxLayoutGap="36px" fxLayoutGap.lt-md="36px"
                        [ngStyle]="{padding: '0 19px 0 0'}" [ngStyle.lt-md]="{padding: '0'}">
                        <div>
                            <div class="color-70" style="font-size: 16px;"
                                [innerHtml]="'IFrame.ImageSite.imageDetails'| translate"></div>
                        </div>

                        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="end" fxLayoutAlign.lt-md="center"
                            fxLayoutGap="18px">
                            <button fxFlex="114px" fxFlex.xs="36px" mat-flat-button class="secondary-btn"
                                (click)="goToAbort()" [disabled]="!sessionService.session"
                                [disabled]="!sessionService.session">
                                {{'IFrame.ImageSite.Abort' | translate}}
                            </button>
                            <button fxFlex="114px" fxFlex.xs="36px" class="primary-btn" mat-flat-button
                                (click)="goToAdress()"
                                [disabled]="!sessionService.session || imageUploadComponent.imageState != 'confirmed'">
                                {{'IFrame.ImageSite.Proceed' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="4rem" fxLayoutGap.lt-md="6rem">
            
            <div fxFlex="50">
                <div class="color-70" style="font-size: 16px;"
                    [innerHtml]="'IFrame.ImageSite.imageDetailsOk'| translate"></div>
            </div>
        </div> -->


        </div>
    </div>
</ng-template>

<ng-template #adressSite>
    <div fxFlex="100" style="margin: 36px" fxLayout="column" fxLayoutGap="9px">
        <div fxLayout="column" style="height: 100%;" fxLayoutGap="18px" fxLayoutGap.lt-md="18px"
            fxLayoutAlign="space-between center">

            <div style="width: 100%">
                <h1 class="color-90" style="margin-bottom: 0;"  >{{'IFrame.AddressSite.Header'|translate}}</h1>
            </div>

            <div fxFlex style="padding-top: 7px; width: 100%;">
                <mat-radio-group class="example-radio-group" aria-label="Select an option"
                    [(ngModel)]="sessionService.shipping">

                    <div fxLayout="column" fxLayoutGap="36px" style="font-size: 16px;">
                        <div fxFlex fxLayout="row" *ngIf="sessionService.session?.allowShipping">
                            <mat-radio-button [attr.aria-label]="'IFrame.AddressSite.Option1' | translate" fxFlex="48px"
                                class="example-radio-button" [value]="1">
                            </mat-radio-button>
                            <div fxFlex="0 1 400px" (click)="sessionService.shipping = 1" style="cursor: pointer;">
                                <div class="option-header">{{'IFrame.AddressSite.Option1' | translate}}</div>
                                <div class="hint-text" [innerHtml]="'IFrame.AddressSite.Option1Info' | translate"></div>
                            </div>
                        </div>

                        <div fxFlex fxLayout="row" *ngIf="sessionService.session?.allowPickup">
                            <mat-radio-button [attr.aria-label]="'IFrame.AddressSite.Option2' | translate" fxFlex="48px"
                                class="example-radio-button" [value]="0">
                            </mat-radio-button>
                            <div fxFlex="0 1 400px" (click)="sessionService.shipping = 0" style="cursor: pointer;">
                                <div class="option-header">{{'IFrame.AddressSite.Option2' | translate}}</div>
                                <div class="hint-text" [innerHtml]="'IFrame.AddressSite.Option2Info' | translate"></div>
                            </div>
                        </div>
                    </div>
                </mat-radio-group>
            </div>

        </div>

        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="end" fxLayoutAlign.lt-md="center" fxLayoutGap="18px">
            <button fxFlex="114px" fxFlex.xs="36px" mat-flat-button class="secondary-btn" (click)="goToAbort()"
                [disabled]="!sessionService.session">
                {{'IFrame.ImageSite.Abort' | translate }}
            </button>
            <button fxFlex="114px" fxFlex.xs="36px" mat-flat-button class="primary-btn" (click)="submit()"
                [disabled]="!sessionService.session">
                {{'IFrame.AddressSite.Proceed' | translate }}
            </button>
        </div>

    </div>
</ng-template>

<ng-template #abortSite>
    <div fxFlex="100" style="margin: 36px" fxLayout="column" fxLayoutGap="9px">
        <div fxLayout="column" style="height: 100%;" fxLayoutGap="24px" fxLayoutAlign="space-between center">
            <div style="width: 100%;">
                <h1 class="color-90">{{ 'IFrame.AbortSite.Header' | translate }}</h1>
            </div>
            <div fxFlex fxLayout="row">
                <div fxFlex>
                    <div class="abort-text" [innerHtml]="'IFrame.AbortSite.abortInfo'|translate"></div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #errorSite>
    <div fxFlex="100" style="margin: 36px" fxLayout="column" fxLayoutGap="9px">
        <div fxLayout="column" style="height: 100%;" fxLayoutGap="24px" fxLayoutAlign="space-between center">
            <div style="width: 100%;">
                <h1 class="color-90">{{'IFrame.ErrorSite.Header' | translate}}</h1>
            </div>
            <div fxFlex fxLayout="row">
                <div class="abort-text" [innerHtml]="'IFrame.ErrorSite.errorInfo' | translate"></div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #successSite>
    <div fxFlex="100" style="margin: 36px" fxLayout="column" fxLayoutGap="9px">
        <div fxLayout="column" fxLayoutGap="24px" style="height: 100%;" fxLayoutAlign="space-between center">
            <div>
                <h1 class="color-90">{{ 'IFrame.SuccessSite.Header' | translate }}</h1>
            </div>
            <div fxFlex fxLayout="row">
                <div fxFlex>
                    <div fxLayout="column" fxLayoutGap="24px">
                        <div fxFlex *ngIf="sessionService.shipping === 0">
                            <div class="abort-subheader">{{ 'IFrame.SuccessSite.subheader1' | translate }}</div>
                            <div class="abort-text" [innerHtml]="'IFrame.SuccessSite.subtext1' | translate"></div>
                        </div>
                        <div fxFlex *ngIf="sessionService.shipping === 1">
                            <div class="abort-subheader">{{ 'IFrame.SuccessSite.subheader2' | translate }}</div>
                            <div class="abort-text" [innerHtml]="'IFrame.SuccessSite.subtext2' | translate"></div>
                        </div>
                        <div fxFlex>
                            <div class="abort-subheader">{{ 'IFrame.SuccessSite.subheader3' | translate }}</div>
                            <div class="abort-text" [innerHtml]="'IFrame.SuccessSite.subtext3'|translate"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #fotoVerzicht>
    <div fxLayout="column" fxFlex="50">
        <mat-checkbox class="example-margin" [(ngModel)]="sessionService.noImage">
            <b>Fotoverzicht</b>
        </mat-checkbox>
        <div style="margin-left: 24px; margin-bottom: 24px">
            <b>Achtung: </b> Bei einem Fotoverzicht kann kein Semesterticket ausgestellt werden, auch wenn bereits dafür
            bezahlt wurde.
        </div>
    </div>
</ng-template>

<ng-template #technicalErrorSite>
    <div fxFlex="100" style="margin: 36px" fxLayout="column" fxLayoutGap="9px">
        <div fxLayout="column" style="height: 100%;" fxLayoutGap="24px" fxLayoutAlign="space-between center">
            <div style="width: 100%;">
                <h1 class="color-90">{{'IFrame.TechnicalErrorSite.Header' | translate}}</h1>
            </div>
            <div fxFlex fxLayout="row" style="width: 100%;">
                <div class="abort-text" [innerHtml]="'IFrame.TechnicalErrorSite.errorInfo' | translate"></div>
            </div>
        </div>
    </div>
</ng-template>